<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-12-08 10:28:54
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimType\components\newApprovalFlow.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-22 10:16:57
-->
<template>
  <normalDialog
    width="700"
    @close="closeDialog"
    scrollable
    :title="$t('label_essweb_ClaimType_form_dilog_newApprovalFlowTitle')"
    :dialog="show"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <normalInputTextFiled
              type="number"
              :label="$t('label_essweb_ClaimType_form_dilog_claimAmountLabel')"
              v-model="approvalFlowData.amount"
              maxlength="10"
              :rules="
                $GetRules(['_Number_negative', '_Length_Rules'], [null, 10])
              "
              :placeholder="
                $t('label_essweb_ClaimType_form_dilog_claimAmountLabel')
              "
            >
              <template v-slot:prepend-inner>
                <span class="mt-1">≥</span>
              </template></normalInputTextFiled
            >
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_ClaimType_form_dilog_approvalTemplateLabel")
            }}</v-sheet>
            <v-autocomplete
              :items="approvalTemplates"
              item-text="flow_template_name"
              item-value="uuid"
              v-model="approvalFlowData.approval_flow_template_uuid"
              append-icon="arrow_drop_down"
              filled
              single-line
              :rules="$GetRules(['_Require_Rules'], [null])"
              :placeholder="
                $t('label_essweb_ClaimType_form_dilog_approvalTemplateLabel')
              "
              dense
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions saveBtn cancelBtn @save="onNew" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newApprovalFlow",
  props: {
    show: { default: false, type: Boolean },
    PropertyData: { default: null, type: Object },
  },
  computed: {
    ...mapGetters(["companyLang"]),
    approvalTemplates() {
      return this.$getSelectTrans(
        this.approvalTemplateData,
        "flow_template_name"
      );
    },
  },
  watch: {
    show(val) {
      if (!val) {
        this.approvalFlowData = {
          uuid: null,
          amount: 0,
          approval_flow_template_uuid: null,
          approval_flow_template_name: this.$getCommonLangKey(this.companyLang),
        };
      }
    },
    PropertyData(val) {
      const that = this;
      if (val) {
        this.$Sleep(200).then(() => {
          // 加延迟解决国际化输入问题
          that.approvalFlowData["uuid"] = val["uuid"];
          that.approvalFlowData["amount"] = val["amount"];
          that.approvalFlowData["approval_flow_template_uuid"] =
            val["approval_flow_template_uuid"];
          that.approvalFlowData["approval_flow_template_name"] =
            val["approval_flow_template_name"];
        });
      } else {
        this.approvalFlowData = {
          uuid: null,
          amount: 0,
          approval_flow_template_uuid: null,
          approval_flow_template_name: this.$getCommonLangKey(this.companyLang),
        };
      }
    },
    "approvalFlowData.approval_flow_template_uuid": function (val) {
      if (!val) {
        this.approvalFlowData.approval_flow_template_name =
          this.$getCommonLangKey(this.companyLang);
      } else {
        let obj = this.approvalTemplateData.find((ele) => ele.uuid === val);
        this.approvalFlowData.approval_flow_template_name =
          obj["flow_template_name"];
      }
    },
  },
  data() {
    return {
      approvalTemplateData: [],
      approvalFlowData: {
        uuid: null,
        amount: 0,
        approval_flow_template_uuid: null,
        approval_flow_template_name: "",
      },
    };
  },
  mounted() {
    this.approvalFlowData.approval_flow_template_name = this.$getCommonLangKey(
      this.companyLang
    );

    this.getApprovalTemplates();
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    getApprovalTemplates: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_templates",
        url: "/approval-template/get-approval-template-list/",
        data: {
          business_data_table_name: "ess_clm_claim_form_records", //bj 2021-07-05
        },
      }).then((res) => {
        that.approvalTemplateData = res.data;
      });
    },
    onNew: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("onNew", this.approvalFlowData);
    },
  },
};
</script>